"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.regexp.search");
var _recommend_activity = require("@/api/goods_activity/recommend_activity");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'RecommendActivityTablePane',
  data: function data() {
    return {
      loading: false,
      tableData: [],
      searchForm: {
        activityName: '',
        status: null
      },
      page: 1,
      limit: 20,
      total: 0
    };
  },
  created: function created() {
    this.search();
  },
  methods: {
    search: function search() {
      var _this = this;
      this.loading = true;
      var params = _objectSpread({
        page: this.page,
        limit: this.limit
      }, this.searchForm);
      (0, _recommend_activity.getRecommendActivityPage)(params).then(function (res) {
        console.log('返回数据:', res);
        console.log('records:', res.records);
        if (res.records && res.records.length > 0) {
          console.log('第一条数据:', res.records[0]);
        }
        _this.tableData = res.records || [];
        _this.total = res.total || 0;
        _this.loading = false;
      }).catch(function (err) {
        console.error('请求失败:', err);
        _this.loading = false;
      });
    },
    resetSearch: function resetSearch() {
      this.searchForm = {
        activityName: '',
        status: null
      };
      this.page = 1;
      this.search();
    },
    handleAdd: function handleAdd() {
      this.$emit('addActivity');
    },
    handleEdit: function handleEdit(row) {
      this.$emit('editActivity', row.activityId);
    },
    handleStatusChange: function handleStatusChange(row) {
      var _this2 = this;
      var statusText = row.status === 1 ? '启用' : '禁用';
      (0, _recommend_activity.toggleActivityStatus)({
        activityId: row.activityId,
        status: row.status
      }).then(function () {
        _this2.$message.success("".concat(statusText, "\u6210\u529F"));
      }).catch(function () {
        // 失败时恢复原状态
        row.status = row.status === 1 ? 0 : 1;
      });
    },
    handleDelete: function handleDelete(row) {
      var _this3 = this;
      this.$confirm('确定要删除该活动吗？删除后无法恢复！', '删除确认', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        type: 'warning',
        distinguishCancelAndClose: true
      }).then(function () {
        (0, _recommend_activity.deleteRecommendActivity)(row.activityId).then(function () {
          _this3.$message.success('删除成功');
          _this3.search();
        });
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.limit = val;
      this.page = 1;
      this.search();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.search();
    },
    getSceneTagType: function getSceneTagType(scene) {
      if (scene.includes('堂食')) return 'success';
      if (scene.includes('自提')) return 'warning';
      if (scene.includes('外卖')) return 'danger';
      return '';
    },
    formatDateTime: function formatDateTime(dateStr) {
      if (!dateStr) return '-';
      var date = new Date(dateStr);
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      var hours = String(date.getHours()).padStart(2, '0');
      var minutes = String(date.getMinutes()).padStart(2, '0');
      var seconds = String(date.getSeconds()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    },
    getTimeTypeClass: function getTimeTypeClass(timeType) {
      switch (timeType) {
        case 1:
          return 'time-type-permanent';
        case 2:
          return 'time-type-period';
        case 3:
          return 'time-type-cycle';
        default:
          return '';
      }
    },
    getTimeTypeIcon: function getTimeTypeIcon(timeType) {
      switch (timeType) {
        case 1:
          return 'el-icon-time';
        case 2:
          return 'el-icon-date';
        case 3:
          return 'el-icon-refresh';
        default:
          return 'el-icon-time';
      }
    }
  }
};